import Head from "next/head";
import CarDetails from "../../../../../components/car-details/car-details-form";
import Footer from "../../../../../components/layout/footer";
import Header from "../../../../../components/layout/header";
import { useRouter } from "next/router";
import { fetchGetAd } from "../../../../../../services/api";
import { capitalize } from "../../../../../../utils/utils";

export default function VehicleDetailsPage({ companyGeneralData, ad }) {
    const router = useRouter();
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={`Está procurando por ${capitalize(router.query.vehicle)} - ${router.query.year}?, veja essa e outras opções disponíveis em nosso estoque`} />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`${companyGeneralData.company.nickName} - ${companyGeneralData.company.city ? companyGeneralData.company.city : ''} - ${capitalize(router.query.vehicle.replace('-', ' '))} - ${router.query.year}`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                <CarDetails ad={ad} company={companyGeneralData.company} />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps({ query }) {
    const ad = await fetchGetAd({ idAd: query.id });
    return { props: { ad } }
}